function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.234375 7.00781L0.453125 7.22656C0.507813 7.28125 0.580729 7.30859 0.671875 7.30859C0.763021 7.30859 0.845052 7.28125 0.917969 7.22656L6.25 1.86719L11.582 7.22656C11.6549 7.28125 11.737 7.30859 11.8281 7.30859C11.9193 7.30859 11.9922 7.28125 12.0469 7.22656L12.2656 7.00781C12.3203 6.95312 12.3477 6.88021 12.3477 6.78906C12.3477 6.69792 12.3203 6.625 12.2656 6.57031L6.46875 0.773438C6.41406 0.71875 6.34115 0.691406 6.25 0.691406C6.15885 0.691406 6.08594 0.71875 6.03125 0.773438L0.234375 6.57031C0.179688 6.625 0.152344 6.69792 0.152344 6.78906C0.152344 6.88021 0.179688 6.95313 0.234375 7.00781Z",
  fill: "currentColor"
});

var SvgChevronUp = function SvgChevronUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 8",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-up.4f730a34.svg";
export { ForwardRef as ReactComponent };